/*
 * @Author: 徐艳龙 w17630400757@163.com
 * @Date: 2022-05-07 08:40:45
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-05-10 16:43:50
 * @FilePath: \新官网\Transfor-website\src\i18n\langs\en.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  language: {
    name: "中文",
  },
  navbar: {
    index: "DO Network",
    index1: "DO Network",
    learn: "Learn",
    technology: "Technology",
    developer: "Developer",
    community: "Community",
    join: ["Join our Autonomous", "Organization."],
    decentralized: "Decentralized",
    website: "Official website architecture.",
    copy: "COPYRIGHT© 2018-2021 DO Network FOUNDATION",
    message:
      "Please don't trust fake accounts. For more info, please follow our offical channels!",
  },
  Main: {
    Sustainable: "Sustainable",
    expansionof: "expansion of",
    low: "low-power",
    decentralized: "decentralized",
    networks: "networks",
    TheTransformers:
      "The Transformers achieved performance breakthroughs on a highly decentralized basis, with the network always open and nodes free to operate without any constraints.",
    AboutTransformers: "About transformers",
    A: "A whole ",
    new: " new ",
    Experience: " experience for you with transformers.",
    With: "with the lightweight Magic Cube consensus protocol in the transformers’ network, transactions can complete two-thirds of the network consensus within 5 seconds, processing thousands of transactions per second.",
    The: "The Transformers network has the scalability of hundreds or even more blocks at the same height and integrates the verification algorithm of the block hash state into the consensus process, effectively improving the transaction capacity and efficiency.",
    Small:
      "Small TFSC payments can complete the network interaction, and complete the transaction time in as fast as 2 seconds.",
    TheBridgin:
      "The bridging node and validator in the Transformers network do not need competitive out of the block, public domain users can freely choose nodes to initiate block proposals to complete the on-chain consensus.",
    lows: "Low energy consumption and high performance",
    On: "On-chain scalability",
    Fast: "Fast and low cost",
    No: "No competition protocol",
    About: "About us",
    Thriving: "A thriving, globalization",
    ecology: " ecology ",
    Is: "is the vision of the transformers.",
    Run: "Run the bridge node",
    server:
      "Sever for transformers network and public domain users to get dividend per minute of network traffic.",
    RunThe: "Run the validator",
    Establish:
      "Establish scattered validator nodes, maintain network security, and obtain the commission delivery of inflation share",
    Self: "Self-government， equality， and freedom is the development idea of the transformers.Sustainable scalability of decentralization is the goal of the transformers.",
  },
  Learning: {
    Overview: "Transformers Overview",
    Transformers:
      "Transformers Chain is an open-source fork network based on The United Engine Chain. It continues and optimizes its lightweight consensus algorithm and renamed it the Magic Cube Consensus protocol, making it decentralized, fast, and with low energy consumption. Through the reconstruction of the incentive layer protocol, the network will enter into harmonious development again. Transformers will build a prosperous global ecosystem with its unique advantages.",
    Understand: "Understand what transformers have been optimized",
    Tobuild: "To build a stronger foundation ",
    for: "for ecological ",
    development: " development",
    Magic: "Magic cube consensus protocol",
    trough:
      "trough the multipath selection of data state by discrete random number algorithm. After the single-path validation results are fully consistent, confirmed the consensus according to the priority of its return response.",
    Network: "Network fragmentation",
    Transformersachieve:
      "Transformers achieve network shard by bridge nodes, the bridge node and the validator will shard the network after one epoch cycle, improving network efficiency and ensuring the security of shard networks.",
    Trading: "Trading shard",
    Inthe:
      "In the Transformers network, complete a large number of transactions by a small number of validators in the shard state and then spread to the entire network, which has a more powerful transaction processing capacity.",
    Ecological: "Ecological economy",
    Willabolish:
      "Will abolish the original block incentive mechanism, and promote the stable development of the Transformers economy through controlled inflation and destruction agreement.",
    IfYou:
      "If you want to learn more about Transformers , click here and get more information",
    GetStarted: "Get started",
    wallet: "Transformers wallet ",
    Be: "Be sure to back up your private key and mnemonic.Do not even think about giving anyone your private key and mnemonic.",
    ios: ["iOS & Android scan code download", "iOS & Android"],
    ImgText: ["App Store", "Android APK", "MacOS", "Windows"],
    WalletGuide: "Wallet guide",
    Transformers:
      "Transformers has a variety of wallet apps that cover all platforms, including ios mac for Android Windows",
    Windows: [
      "Windows",
      "Installation guide for installing transformers wallets under Windows",
    ],
    MacOS: [
      "Mac OS",
      "Installation guide for installing transformers wallets under Mac OS",
    ],
    Android: [
      "Android",
      "Installation guide for installing transformers wallets under android",
    ],
    iOS: [
      "iOS",
      "Installation guide for installing transformers wallets under iOS",
    ],
  },
  Ecological: {
    Ecological: "Ecological",
    development: " development",
    TransformersWill:
      "Transformers will plan 10 million dollars for early bird ecological project development support",
    Why: "Why join Transformers",
    Transformers:"Transformers",
    Venture: " Venture fund",
    Apply: "Apply venture fund",
    Come: ["Come on and apply for transformers’",'earliest ',"venture fund"],
    Tell: "Tell us your thoughts, and we will try to give you the most valuable help ",
    ApplyNow: "Apply now",
    WhyJoin: "Why join Transformers",
    ecology: ["Transformers ecology’s upcoming"," early bird ","project"],
  },
  collective: {
    Join: "Join",
    Transformers: " Transformers ",
    collective: "collective",
    Let: "Let us grow together with The Transformers, with enthusiasm and expertise to help the Transformers better future.",
    About: "About us",
    Post: "Post your application form here， join Transformers big family",
  },

  footer: {
    New: "New experience for you with transformers.",
    Self: "Self-government， equality， and freedom is the development idea of the transformers.",
   // Tranformers: "©2023 - Transformers, Inc.",
    Tranformers: "©2023 Tick Wallet-UQC Capital Formation",
    about:
      "DO Network Explorer is the official blockchain explorer of DO network, providing blocks, addresses, transactions, staking queries and statistics service.",
    email: "Email: donetwork@outlook.com",
    Apply: "Apply to join",
  },
};
